import { Box, Button, Modal } from '@qwealth/qcore';
import { ACTION_CONFIRMATION_EDIT, ActionConfirmationOptions } from 'data/models/Activity';
import React, { ReactElement, useEffect, useState } from 'react';
import { BsTrash } from 'react-icons/bs';
import RecurringTaskActionConfirmationBodyText from '../RecurringTaskActionConfirmationBodyText';

interface Props {
  primaryButtonActionHandler: () => void;
  secondaryButtonActionHandler: () => void;
  Icon?: ReactElement;
  taskTitle: string;
  actionConfirmation: ActionConfirmationOptions;
  ActionButtonRenderer?: (openHandler: () => void) => React.ReactElement | null;
  buttonProps?: any;
  setIsTaskModalHidden?: React.Dispatch<React.SetStateAction<boolean>>;
}

const RecurringTaskActionConfirmation: React.FC<Props> = ({
  primaryButtonActionHandler,
  secondaryButtonActionHandler,
  Icon,
  taskTitle,
  actionConfirmation,
  ActionButtonRenderer,
  buttonProps,
  setIsTaskModalHidden,
}) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const onClose = () => {
    setShowConfirmation(false);
    setIsTaskModalHidden ? setIsTaskModalHidden(false) : undefined;
  };

  const handleOpenModal = () => {
    setShowConfirmation(true);
    setIsTaskModalHidden ? setIsTaskModalHidden(true) : undefined;
  };
  const isEdit = actionConfirmation === ACTION_CONFIRMATION_EDIT;

  return (
    <>
      {ActionButtonRenderer ? (
        ActionButtonRenderer(() => handleOpenModal())
      ) : (
        <Button id="confirmationButton" variant="icon" backgroundColor="transparent" onClick={() => handleOpenModal()} {...buttonProps}>
          {Icon || <BsTrash />}
        </Button>
      )}
      <Modal title={isEdit ? 'Change Confirmation' : 'Delete Confirmation'} onClose={onClose} show={showConfirmation} size="lg">
        <Modal.Body>
          <RecurringTaskActionConfirmationBodyText
            action={actionConfirmation}
            taskTitle={taskTitle}
            {...(isEdit && {
              note: (
                <Box as="ul" display="flex" flexDirection="column" gap="default">
                  <Box as="li">Any attachments you add will be saved to all past and future occurrences of this task.</Box>
                  <Box as="li">
                    Editing Assigned, Status, Priority and Due Date fields will only affect the current task occurrence and not propagate to all
                    future recurring tasks.
                  </Box>
                </Box>
              ),
            })}
          />
        </Modal.Body>
        <Modal.Footer>
          <Box flexDirection="row" display="flex" gap="large" justifyContent="center" width="100%">
            <Button
              onClick={() => {
                primaryButtonActionHandler();
                onClose();
              }}
            >
              This Task
            </Button>
            <Button
              onClick={() => {
                secondaryButtonActionHandler();
                onClose();
              }}
            >
              All Tasks
            </Button>
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
          </Box>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RecurringTaskActionConfirmation;
